import { cloneDeep } from 'lodash';

import { captureChunkLoadException } from '../../service/ErrorsReporting/ErrorsReporting';

import { TemplateListItem, VideoCreatorTemplate } from './typings';

export enum VideoCreatorPath {
    template = './templates/'
}

export class VideoCreatorHelpers {
    static getTemplateList(): Promise<TemplateListItem[]> {
        return import(
            /* webpackChunkName: "templatesList" */
            /* webpackMode: "lazy" */
            './templatesList.json'
        )
            .then(({ default: templateList }) => cloneDeep(templateList))
            .catch(error => captureChunkLoadException(error, 'templatesList'));
    }

    static getTemplateById(id: string): Promise<VideoCreatorTemplate> {
        return import(
            /* webpackChunkName: "template" */
            /* webpackMode: "lazy" */
            `${VideoCreatorPath.template}${id}`
        )
            .then(({ default: template }) => cloneDeep(template))
            .catch(error => captureChunkLoadException(error, 'template'));
    }
}
